import React from 'react';
import Moment from 'moment';
import {
  DragSourceAndDropTarget,
  DragAndDropSpace,
} from '../../components/DnDWrapper';
import { isApiFlagOn } from '../../utilities/commonUtil';

const groupSettingValueTable__menu = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  const isIE = ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0;
  return isIE ? { minWidth: 'auto', textAlign: 'left' } : {};
};

/**
 * グループ設定のコンテンツ
 *
 * @param {*} {
 *   groupSettings,
 *   callbacks,
 *   canDrag,
 *   infinityScrollLoad,
 * }
 * @returns
 */
export const GroupSettingContents = ({
  groupSettings,
  callbacks,
  canDrag,
  infinityScrollLoad,
}) => {
  const DndSpace = element => {
    return <DragAndDropSpace>{element}</DragAndDropSpace>;
  };

  return DndSpace(
    <div className='setting-main__table'>
      <table className='setting-table'>
        <thead className='setting-table__header'>
          <tr className='setting-table__label'>
            {/* 並び替え */
            canDrag && (
              <td className='value-table group-setting-value-table__drag'>
                <div className='value-table__label' />
              </td>
            )}
            <td className='value-table group-setting-value-table__status'>
              <div className='value-table__label'>ステータス</div>
            </td>
            <td className='value-table group-setting-value-table__name'>
              <div className='value-table__label'>グループ名</div>
            </td>
            <td className='value-table group-setting-value-table__name'>
              <div className='value-table__label'>ふりがな</div>
            </td>
            <td className='value-table group-setting-value-table__date'>
              <div className='value-table__label'>登録日時</div>
            </td>
            <td className='value-table group-setting-value-table__date'>
              <div className='value-table__label'>更新日時</div>
            </td>
            <td className='value-table group-setting-value-table__menu'>
              <div className='value-table__label' />
            </td>
          </tr>
        </thead>
        <tbody>
          {groupSettings.map((groupSetting, index) => {
            return (
              <GroupSetting
                key={groupSetting.id}
                index={index}
                groupSetting={groupSetting}
                callbacks={callbacks}
                canDrag={canDrag}
              />
            );
          })}
          {}
        </tbody>
      </table>
      {infinityScrollLoad}
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const getStatus = (groupSetting, onChangeStatus) => {
  if (groupSetting.display_flag === 1) {
    return <span className='setting-status-using'>使用中</span>;
  }
  return <span className='setting-status'>未使用</span>;
};

/**
 * ドラッグ&ドロップ時
 *
 * @param {*} { index, groupSetting, callbacks, canDrag }
 * @returns
 */
const GroupSetting = ({ index, groupSetting, callbacks, canDrag }) => {
  const DndSrcTgt = element => {
    // ドラッグさせるかどうか
    if (canDrag && isApiFlagOn(groupSetting.display_flag)) {
      return (
        <DragSourceAndDropTarget
          id={`groupDnD`}
          index={index}
          data={groupSetting}
          onHover={callbacks.dnd.onHover.bind(this)}
          onBeginDrag={callbacks.dnd.onBeginDrag.bind(this)}
          onDropped={callbacks.dnd.onDropped.bind(this)}
          canDrag={true}
          canDrop={true}
        >
          {element}
        </DragSourceAndDropTarget>
      );
    }

    return element;
  };

  return DndSrcTgt(
    <tr id={`group-${groupSetting.id}`} className='setting-table__item'>
      {/* 並び替え */
      canDrag && (
        <td className='group-setting-value-table__drag'>
          <button
            className='btn-icon--sm'
            style={{
              display:
                // ドラッグ可能かどうか
                isApiFlagOn(groupSetting.display_flag)
                  ? 'inline-block'
                  : 'none',
            }}
          >
            <i className='i-drag i-3x' />
          </button>
        </td>
      )}
      <td className='group-setting-value-table__status'>
        {getStatus(groupSetting)}
      </td>
      <td className='group-setting-value-table__name'>
        <span className='label'>グループ名</span>
        <p>{groupSetting.name}</p>
      </td>
      <td className='group-setting-value-table__name'>
        <span className='label'>ふりがな</span>
        <p>{groupSetting.kana}</p>
      </td>
      <td className='group-setting-value-table__date'>
        <span className='label'>登録日時</span>
        <p className='date-long'>
          <span className='date-long__date'>
            {Moment(groupSetting.created_at).format('YYYY/MM/DD')}
          </span>
          <span className='date-long__time'>
            {Moment(groupSetting.created_at).format('HH:mm')}
          </span>
        </p>
      </td>
      <td className='group-setting-value-table__date'>
        <span className='label'>更新日時</span>
        <p className='date-long'>
          <span className='date-long__date'>
            {Moment(groupSetting.updated_at).format('YYYY/MM/DD')}
          </span>
          <span className='date-long__time'>
            {Moment(groupSetting.updated_at).format('HH:mm')}
          </span>
        </p>
      </td>
      <td
        className='group-setting-value-table__menu'
        style={groupSettingValueTable__menu()}
      >
        <div className='setting-edit-btn'>
          <button
            className='btn--sm--stay'
            onClick={() => {
              !canDrag && callbacks.table.edit(groupSetting);
            }}
            style={{ display: canDrag ? 'none' : 'inline-block' }}
          >
            編集
          </button>
        </div>
      </td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/GroupSetting.jsx